import { graphql } from "@/api/graphql/types/gql";

export const SearchAccountsQuery = graphql(`
  query AccountsMsSearchAccounts($request: AccountsMsSearchAccountsRequest) {
    AccountsMsSearchAccounts(request: $request) {
      data {
        id
        name
        number
        registrationName
        registrationNumber
        isActive
      }
    }
  }
`);
